import {FieldConfig} from '../../dynamic-field/field.config';

export interface CustomFieldConfig extends FieldConfig<string> {
}
